import React from 'react';
import { Mail, Clock, Sparkles } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="relative py-24 md:py-32 bg-paper-3/40 border-y border-rule-soft">
      <div className="frame">
        {/* Masthead */}
        <header className="grid grid-cols-12 gap-x-6 lg:gap-x-10 items-end pb-6 border-b border-ink">
          <div className="col-span-12 lg:col-span-5 flex items-center gap-3">
            <span className="section-num">08 / Contact</span>
            <span className="label-muted">Get in touch</span>
          </div>
          <div className="col-span-12 lg:col-span-7 mt-6 lg:mt-0">
            <h2 className="display-lg">
              Get in <span className="text-accent">Touch</span>
            </h2>
            <p className="mt-5 max-w-measure text-ink-soft leading-relaxed">
              Ready to transform your ideas into powerful applications? Contact us today.
            </p>
          </div>
        </header>

        {/* Two main cards */}
        <div className="mt-10 md:mt-14 max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Email Us */}
            <div className="card-tech p-8 group text-center">
              <div className="w-16 h-16 bg-ink text-paper flex items-center justify-center mx-auto group-hover:bg-lime group-hover:text-ink transition-colors">
                <Mail className="w-7 h-7" strokeWidth={1.5} />
              </div>
              <h3 className="mt-5 font-display font-semibold text-xl md:text-2xl tracking-tight text-ink">
                Email Us
              </h3>
              <a
                href="mailto:support@charliecollc.com"
                className="link-underline mt-3 inline-block font-mono text-base md:text-lg text-accent hover:text-ink transition-colors break-all"
              >
                support@charliecollc.com
              </a>
              <p className="mt-3 text-ink-soft text-sm">
                We respond within 24 hours
              </p>
            </div>

            {/* Business Hours */}
            <div className="card-tech p-8 group text-center">
              <div className="w-16 h-16 bg-ink text-paper flex items-center justify-center mx-auto group-hover:bg-lime group-hover:text-ink transition-colors">
                <Clock className="w-7 h-7" strokeWidth={1.5} />
              </div>
              <h3 className="mt-5 font-display font-semibold text-xl md:text-2xl tracking-tight text-ink">
                Business Hours
              </h3>
              <p className="mt-3 font-display font-semibold text-lg md:text-xl text-accent">
                24/7 Support
              </p>
              <p className="mt-3 text-ink-soft text-sm">
                Always available for your needs
              </p>
            </div>
          </div>

          {/* Final CTA panel */}
          <div className="mt-8 card-tech p-8 md:p-10 text-center bg-ink text-paper border-ink">
            <Sparkles className="w-7 h-7 text-lime mx-auto mb-4" strokeWidth={1.5} />
            <h3 className="font-display font-semibold text-2xl md:text-3xl tracking-tight text-paper">
              Start Your Project Today
            </h3>
            <p className="mt-4 max-w-xl mx-auto text-paper/80 leading-relaxed">
              Whether you need a mobile app, web application, or enterprise solution,
              our expert team is ready to bring your vision to life.
            </p>
            <a
              href="mailto:support@charliecollc.com?subject=Project Inquiry"
              className="btn-lime mt-6 inline-flex"
            >
              <Mail className="w-4 h-4" strokeWidth={2} />
              <span>Contact Us Now</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
